<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div :class="className + '__link gnb__link--toggle d-xl-none'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link :to="item.path" :class="className + '__link gnb__link--toggle d-none d-xl-flex'">
                    <h2>{{ item.title }}</h2>
                </router-link>
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                // 추후 아래의 상태로 되돌릴 예정입니다.
                {
                    title: "메인",
                    path: "/",
                },
                {
                    title: "e커머스피칭페스타",
                    path: "/pitching-festa",
                    children: [
                        {
                            title: "소개",
                            path: "/pitching-festa",
                        },
                        {
                            title: "지원",
                            path: "/pitching-festa/support",
                        },
                        {
                            title: "스타트업",
                            path: "/pitching-festa/startup",
                        },
                    ],
                },
                {
                    title: "유통데이터 활용 경진대회",
                    path: "/circulation",
                    children: [
                        {
                            title: "소개",
                            path: "/circulation",
                        },
                        {
                            title: "지원",
                            path: "/circulation/support",
                        },
                        {
                            title: "주요자료",
                            path: "/circulation/data",
                        },
                    ],
                },
                {
                    title: "교육·법률지원",
                    path: "/education",
                    children: [
                        {
                            title: "교육소개",
                            path: "/education",
                        },
                        {
                            title: "교육접수",
                            path: "/education/receipt",
                        },
                        {
                            title: "법률지원",
                            path: "/education/law",
                        },
                    ],
                },
                {
                    title: "공지사항·자료실",
                    path: "/center/notice",
                },
                // {
                //     title: "e커머스피칭페스타 소개",
                //     path: "/",
                // },
                // {
                //     title: "지원",
                //     path: "/pitching-festa/support",
                // },
                // {
                //     title: "Navigation 02",
                //     path: "/",
                // },
                // {
                //     title: "Navigation 03",
                //     path: "/",
                // },
                // {
                //     title: "Navigation 04",
                //     path: "/",
                // },
                // {
                //   title: "About",
                //   path: "/about-mission",
                //   children: [
                //     {
                //       title: "About & Mission",
                //       path: "/about-mission",
                //     },
                //     {
                //       title: "공지사항",
                //       path: "/center/notice",
                //     },
                //     {
                //       title: "언론보도",
                //       path: "/board/press",
                //     },
                //     {
                //       title: "위치안내",
                //       path: "/location",
                //     },
                //   ],
                // },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>
